import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { catchError, filter } from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { environment } from '../../../environments/environment';
import { CohortOrgDateDTO } from './cohortorgdate.dto';
import { FilterConfigDTO } from './filterConfig.dto';
import { OrganizationDTO } from '../../comparegroup/organization.dto';
import { CompareGroupDTO } from '../../comparegroup/compare-group.dto';
import { UserFilterStateDTO } from './userfilterstate.dto';
import { NameValuePair } from './namevaluepair.model';
import { unix } from 'moment';

//import { AuthService } from './authservice.service';

@Injectable({
  providedIn: 'root'
})
export class FilterService {

  constructor(private http: HttpClient) { }

  getCohortsFromOrg(orgSelected: string): Observable<CohortOrgDateDTO[]> {
    const apiUrl = environment.baseAPIURL + `getCohortsFromOrg`;
    var req = { orgSelected: orgSelected };
    return this.http.post<CohortOrgDateDTO[]>(apiUrl, req);
  }

  getFilterConfigData(): Observable<FilterConfigDTO> {
    const apiUrl = environment.baseAPIURL + `GetFilterConfigData`;
    return this.http.get<any>(apiUrl);
  }
  getSystemAndOrgsFromEmailForFilter(): Observable<OrganizationDTO[]> {
    const apiUrl = environment.baseAPIURL + `GetSystemAndOrgsFromEmailForFilter`;
    return this.http.get<OrganizationDTO[]>(apiUrl);
  }
  GetCompareGroupsFromOrg(orgSelected: string): Observable<CompareGroupDTO[]> {
    const apiUrl = environment.baseAPIURL + `GetCompareGroupsFromOrg`;
    var req = { orgSelected: orgSelected };
    return this.http.post<CompareGroupDTO[]>(apiUrl, req);
  }
  GetUserFilterState(): Observable<UserFilterStateDTO> {
    const apiUrl = environment.baseAPIURL + `GetUserFilterState`;
    return this.http.get<UserFilterStateDTO>(apiUrl);
  }
  SaveUserFilterState(systemSelectedArr: string[], orgSelectedArr: string[], compareGroupSelectedArr: string[], userId: string, IsSelfCompareGroup: boolean, delimiter): Observable<boolean> {
    let userfilterstate: UserFilterStateDTO = { systemSelected: systemSelectedArr.join(delimiter), orgSelected: orgSelectedArr.join(delimiter), compareGroupSelected: compareGroupSelectedArr.join(delimiter), userId: userId, isSelfCompareGroup: IsSelfCompareGroup };
    const apiUrl = environment.baseAPIURL + `SaveUserFilterState`;
    return this.http.post<boolean>(apiUrl, userfilterstate);
  }

  GetCommentsCountByPeriod(systemSelectedArr: string[], orgSelectedArr: string[], yearHiredArr: string[], cohortSelectedArr: string[], AgeSelectedArr: string[]
    , DegreeAwardedSelectedArr: string[], EthnicitySelectedArr: string[], GenderSelectedArr: string[], GPASelectedArr: string[], PreviousDegreeSelectedArr: string[]
    , UnitSelectedArr: string[], AllSelectedText = 'All', delimiter = '|', reportName: string): Observable<string[]> {
    let userfilterstate = {
      systemSelected: this.checkIfAllSelected(systemSelectedArr, AllSelectedText) ? AllSelectedText : systemSelectedArr.join(delimiter),
      orgSelected: this.checkIfAllSelected(orgSelectedArr, AllSelectedText) ? AllSelectedText : orgSelectedArr.join(delimiter),
      yearSelected: this.checkIfAllSelected(yearHiredArr, AllSelectedText) ? AllSelectedText : yearHiredArr.join(delimiter),
      cohortSelected: this.checkIfAllSelected(cohortSelectedArr, AllSelectedText) ? AllSelectedText : cohortSelectedArr.join(delimiter),
      ageSelected: this.checkIfAllSelected(AgeSelectedArr, AllSelectedText) ? AllSelectedText : AgeSelectedArr.join(delimiter),
      degreeAwardedSelected: this.checkIfAllSelected(DegreeAwardedSelectedArr, AllSelectedText) ? AllSelectedText : DegreeAwardedSelectedArr.join(delimiter),
      ethnicitySelected: this.checkIfAllSelected(EthnicitySelectedArr, AllSelectedText) ? AllSelectedText : EthnicitySelectedArr.join(delimiter),
      genderSelected: this.checkIfAllSelected(GenderSelectedArr, AllSelectedText) ? AllSelectedText : GenderSelectedArr.join(delimiter),
      gpaSelected: this.checkIfAllSelected(GPASelectedArr, AllSelectedText) ? AllSelectedText : GPASelectedArr.join(delimiter),
      previousDegreeSelected: this.checkIfAllSelected(PreviousDegreeSelectedArr, AllSelectedText) ? AllSelectedText : PreviousDegreeSelectedArr.join(delimiter),
      unitSelected: this.checkIfAllSelected(UnitSelectedArr, AllSelectedText) ? AllSelectedText : UnitSelectedArr.join(delimiter)
    };
    var req = {
      filterstate: userfilterstate,
      delimiter: delimiter,
      reportName: reportName
    }
    const apiUrl = environment.baseAPIURL + `GetCommentsCountByPeriod`;
    return this.http.post<string[]>(apiUrl, req);
  }

  private checkIfAllSelected(arr: string[], AllSelectedText: string): boolean {
    if (!(arr) || arr.length == 0 || arr.indexOf(AllSelectedText) > -1)
      return true;
    else return false;
  }

}
